// @flow

import { type PendingIncomingPayment } from './types';

export function getRedirectUrlForPendingPayment(incomingPayment: PendingIncomingPayment): ?string {
  if (incomingPayment.v2 && incomingPayment.v2.redirect)
    return incomingPayment['v2']['redirect']['redirect_url_for_pending_payment'];

  return incomingPayment['redirect_url_for_pending_payment'];
}
